import { GroupAPIResponse } from '../../../service/group/group.model';
import { NormalizedGroup } from '../GroupsAdapter';

export enum BusinessLayerGroupType {
  Market = 'market',
  Markets = 'markets',
  BusinessUnit = 'businessUnit',
  BusinessUnits = 'businessUnits',
  Region = 'region',
  District = 'district',
  Store = 'store',
  Unknown = 'unknown',
}

export interface BusinessLayerLevels {
  businessUnit?: string;
  store?: string;
}

export interface HierarchyLevel {
  label: string;
  role: string;
  id: number;
  generalSettings?: boolean;
  storeView?: boolean;
}

export function parseLevelsFromHierarchy(
  hierarchyJson?: string
): BusinessLayerLevels {
  if (!hierarchyJson) return {};
  try {
    const hierarchy: HierarchyLevel[] = JSON.parse(hierarchyJson);
    return {
      businessUnit: hierarchy.find((h) => h.generalSettings)?.id?.toString(),
      store: hierarchy.find((h) => h.storeView)?.id?.toString(),
    };
  } catch {
    return {};
  }
}

export function getTypeFromGroup(
  group?: GroupAPIResponse | NormalizedGroup,
  marketId?: string,
  isAdmin?: boolean,
  levels?: BusinessLayerLevels
) {
  if (
    group?.attributes?.['FS_BusinessUnit_ID'] ||
    (levels?.businessUnit &&
      group?.attributes?.['FS_LEVEL'] === levels.businessUnit)
  )
    return BusinessLayerGroupType.BusinessUnit;
  if (group?.attributes?.['FS_Region_ID']) return BusinessLayerGroupType.Region;
  if (group?.attributes?.['FS_Market_ID'])
    return BusinessLayerGroupType.District;
  if (
    group?.attributes?.['FS_Store_ID'] ||
    (levels?.store && group?.attributes?.['FS_LEVEL'] === levels.store)
  )
    return BusinessLayerGroupType.Store;
  if (marketId) return BusinessLayerGroupType.Market;
  if (isAdmin) return BusinessLayerGroupType.Markets;
  if (!group) return BusinessLayerGroupType.BusinessUnits;
  return BusinessLayerGroupType.Unknown;
}
